// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SpecimenSampleUploadForm__wrapper__7kqCZ","submitResult":"SpecimenSampleUploadForm__submitResult__1Ktbi","actionWrapper":"SpecimenSampleUploadForm__actionWrapper__3843W","wrapper2faOptions":"SpecimenSampleUploadForm__wrapper2faOptions__2bBFs"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SpecimenSampleEditor/SpecimenSampleUploadForm/SpecimenSampleUploadForm.css
// module id = 3259
// module chunks = 0